// extracted by mini-css-extract-plugin
export default {"with-info-button":"Forms_with-info-button__Ax8ni"};